import { TOGGLE_DARK_MODE } from '../constants';

const initialState = {
  isDarkMode: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_DARK_MODE:
      return {
        ...state,
        isDarkMode: !state.isDarkMode
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/viewModeReducers.js